
/**
 * AES加密 ：字符串 key iv  返回base64 
 */
import CryptoJS from "crypto-js";
 export function encrypt(word, keyStr, ivStr) {
		// 加密
		keyStr = keyStr ||"1626490209123456";
		ivStr = ivStr ||"1626490209123456";
		let key = CryptoJS.enc.Utf8.parse(keyStr);
		let iv = CryptoJS.enc.Utf8.parse(ivStr);
		let srcs = CryptoJS.enc.Utf8.parse(word);
		let encrypted = CryptoJS.AES.encrypt(srcs, key, {
			iv,
			mode: CryptoJS.mode.CBC,
			padding: CryptoJS.pad.Pkcs7
		});
		return encrypted.toString();
	}
	export function  decrypt(word, keyStr, ivStr) {
		// 解密
		keyStr = keyStr ||"1626490209123456";
		ivStr = ivStr ||"1626490209123456";
		var key = CryptoJS.enc.Utf8.parse(keyStr);
		let iv = CryptoJS.enc.Utf8.parse(ivStr);
		var decrypts = CryptoJS.AES.decrypt(word, key, {
			iv,
			mode: CryptoJS.mode.CBC,
			padding: CryptoJS.pad.Pkcs7
		});
		return decrypts.toString(CryptoJS.enc.Utf8);
	}
export function listToRouter(list, parentId) {
    //  arr 是返回的数据  parendId 父id
    let array = [];
    list.forEach((item, i) => {
        item.meta = { hidden: false, auth: true, id: item.id, parent: item.parent, powerId: item.powerId,englishName:item.englishName,name:item.name,params:item.params,template:false,button:item.button ,pageName:item.pageName,isColumns:item.isColumns }
        if (item.parent == parentId) {
            if (listToRouter(list, list[i].id).length > 0) {
                // 递归调用此函数
                list[i].children = listToRouter(list, list[i].id);
            } else {
                list[i].children = null;
            }
            array.push(list[i]);
        }
    });
    return array;
}
export function listToTree(list,parent) {
    list.forEach(item => {
        let parentId = item.parentId;
        if(parentId !=parent){
            list.forEach(items => {
                if(items.id == parentId){ //当内层循环的ID== 外层循环的parendId时，（说明有children），需要往该内层id里建个children并push对应的数组；
                    if(!items.children){
                        items.children = [];
                    }
                    items.children.push(item);
                }
            });
        }
    });
  return list.filter(item => item.parentId == parent); //这一步是过滤，按树展开，将多余的数组剔除；
}

export function treeToList (list, array = []) {
      list.forEach((item) => {
        const { children } = item
        if (children) {
          delete item.children
          if (children.length) {
            array.push(item)
            return treeToList(children, array)
          } 
        }
        array.push(item)
      })
      return array
}
